import { BrowserRouter as Router, Routes, Route, useLocation, Link, Navigate, useNavigate } from 'react-router-dom';
import Registration from './components/Registration.jsx';
import Login from './components/Login.jsx';
import PhotoUpload from './components/PhotoUpload.jsx';
import Dashboard from './components/Dashboard.jsx';
import AdminPanel from './components/AdminPanel.jsx';
import AdminLogin from './components/AdminLogin.jsx';
import './App.css';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isUserPage = location.pathname.startsWith('/upload/') || location.pathname.startsWith('/dashboard/');
  const isAdminPage = location.pathname === '/admin';

  const handleUserLogout = () => {
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('userName');
    navigate('/login');
  };

  const handleAdminLogout = () => {
    sessionStorage.removeItem('adminToken');
    navigate('/admin/login');
  };

  const handleLogoClick = (e) => {
    e.preventDefault();
    const userName = sessionStorage.getItem('userName');
    if (userName) {
      navigate(`/dashboard/${encodeURIComponent(userName)}`);
    } else {
      navigate('/register');
    }
  };

  return (
    <header className="App-header">
      <button onClick={handleLogoClick} className="header-logo">
        <img src="/logo192.png" alt="Imaginary Logo" style={{ height: '40px', width: 'auto', borderRadius: '8px' }} />
        <h1>Imaginary</h1>
      </button>
      <div className="header-actions">
        {isUserPage && (
          <button onClick={handleUserLogout} style={{ border: 'none', cursor: 'pointer', color: 'white', fontWeight: 'bold', padding: '0.5rem 1rem', background: 'rgba(239, 68, 68, 0.8)', borderRadius: '6px' }}>
            Logout User
          </button>
        )}

        {!isUserPage && !location.pathname.startsWith('/admin') && (
          <>
            {location.pathname !== '/login' && (
              <Link to="/login" style={{ color: 'white', textDecoration: 'none', fontWeight: 'bold', padding: '0.5rem 1rem', background: 'rgba(59, 130, 246, 0.8)', borderRadius: '6px' }}>
                User Login
              </Link>
            )}
            {location.pathname !== '/register' && (
              <Link to="/register" style={{ color: 'white', textDecoration: 'none', fontWeight: 'bold', padding: '0.5rem 1rem', background: 'rgba(16, 185, 129, 0.8)', borderRadius: '6px' }}>
                Register
              </Link>
            )}
          </>
        )}

        {isAdminPage ? (
          <button onClick={handleAdminLogout} style={{ border: 'none', cursor: 'pointer', color: 'white', fontWeight: 'bold', padding: '0.5rem 1rem', background: 'rgba(239, 68, 68, 0.8)', borderRadius: '6px' }}>
            Logout Admin
          </button>
        ) : (
          <Link to="/admin" style={{ color: 'white', textDecoration: 'none', fontWeight: 'bold', padding: '0.5rem 1rem', background: 'rgba(255,255,255,0.2)', borderRadius: '6px' }}>
            Admin Panel
          </Link>
        )}
      </div>
    </header>
  );
};

const AppContent = () => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  return (
    <div className="App">
      <Header />
      <main className={isAdmin ? 'admin-main-wrapper' : 'user-main-wrapper'}>
        <Routes>
          <Route path="/" element={<Navigate to="/register" replace />} />
          <Route path="/register" element={<Registration />} />
          <Route path="/login" element={<Login />} />
          <Route path="/upload/:userName" element={<PhotoUpload />} />
          <Route path="/dashboard/:userName" element={<Dashboard />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/admin/login" element={<AdminLogin />} />
        </Routes>
      </main>
    </div>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
